import {toast} from 'sonner';
import {faCheck} from '@fortawesome/free-solid-svg-icons';
import Icon from "../Icon";
import React from "react";

export function successToast(message) {
    return toast.custom(() => (
        <div className="px-8 py-4 rounded-1.5 flex gap-4 items-center text-white font-medium bg-primary-light">
            <Icon icon={faCheck} />
            {message}
        </div>
    ));
}